import { useDispatch, useSelector } from "react-redux";
import { changeStatus, departmentContactState, onFetchDepartmentContacts, onSetSelectedDepartmentContact, onSetTotalRows } from "../redux/slices/departmentContactSlice";
import { ApiStatus } from "../types/api/status";
import { DepartmentContactAPI } from "../apis/DepartmentContactAPI";
import { CustomSnackbar } from "../components/common/CustomSnackbar/CustomSnackbar";
import { DepartmentContact } from "../types/slices/departmentContactType";

export const useDepartmentContactStore = () => {
    const dispatch = useDispatch();
    const { status, departmentContacts, errorMessage, selectedDepartmentContact } = useSelector(departmentContactState)

    const getDepartmentContacts = async (data?: object) => {
        dispatch(dispatch(changeStatus(ApiStatus.FETCHING)))
        try {
            const response = await DepartmentContactAPI.get(data)
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || '')

                return false;
            }

            const { detail, total } = response.data

            dispatch(onFetchDepartmentContacts(detail || []))
            dispatch(onSetTotalRows(total || 0))

            return true
        } catch (error) {
            dispatch(changeStatus(ApiStatus.FETCHED))
            console.error(error)

            return false
        }
    }

    const createDepartmentContact = async (payload: object) => {
        dispatch(dispatch(changeStatus(ApiStatus.FETCHING)))
        try {
            const response = await DepartmentContactAPI.create(payload)
            if (response?.code === 400) {
                CustomSnackbar('error', response?.data?.message || '')
                dispatch(changeStatus(ApiStatus.FETCHED))
                return false
            }

            dispatch(changeStatus(ApiStatus.FETCHED))
            CustomSnackbar('success', response?.data?.message || '')

            return true
        } catch (error) {
            console.error(error)
            dispatch(changeStatus(ApiStatus.FETCHED))

            return false
        }
    }

    const updateDepartmentContact = async (id: number, payload: object) => {
        dispatch(changeStatus(ApiStatus.FETCHING))
        try {
            const response = await DepartmentContactAPI.update(id, payload)
            if (response?.code === 400) {
                CustomSnackbar('error', response?.data?.message || '')
                dispatch(changeStatus(ApiStatus.FETCHED))
                return false
            }
            dispatch(changeStatus(ApiStatus.FETCHED))
            CustomSnackbar('success', response?.data?.message || '')
            return true
        } catch (error) {
            console.error(error)
            dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const deleteDepartmentContact = async (id: number) => {
        dispatch(changeStatus(ApiStatus.FETCHING))
        try {
            const response = await DepartmentContactAPI.delete(id)
            if (response?.code === 400) {
                CustomSnackbar('error', response?.data?.message || '')
                dispatch(changeStatus(ApiStatus.FETCHED))
                return false
            }
            dispatch(changeStatus(ApiStatus.FETCHED))
            CustomSnackbar('success', response?.data?.message || '')
            return true
        } catch (error) {
            console.error(error)
            dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    
    const setSelectedContactDepartment = (payload: DepartmentContact | undefined): void => {
        dispatch(onSetSelectedDepartmentContact(payload))
    }
    return {
        status,
        departmentContacts,
        selectedDepartmentContact,
        getDepartmentContacts,
        createDepartmentContact,
        updateDepartmentContact,
        deleteDepartmentContact,
        setSelectedContactDepartment
    }
}